import {getRestProps} from '../utils';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    let {
    className, children, text, disabled, max
} = self.get();

if (typeof text === 'number' && max && text > max) {
    text = `${max}+`;
}

const classNameObj = {
    'k-badge': true,
    [className]: className,
    'k-has-text': text != null,
    'k-alone': !children,
};

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (children )} catch(e) {_e(e)}}.call($this),
        function() {try {return (!disabled )} catch(e) {_e(e)}}.call($this) ?
            h('sup', null, function() {try {return (text )} catch(e) {_e(e)}}.call($this), 'k-text') :
            undefined
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}